export default __webpack_public_path__ + "static/media/woowa.af505101.svg";